import React, { useState, useEffect, useMemo } from "react";
import { BsThreeDotsVertical } from "react-icons/bs";
import { Link } from "react-router-dom";
import DataTable, { createTheme } from "react-data-table-component";
import { useAtom } from "jotai";
import classes from "../../../assets/styles/Contact.module.css";
import { MEMORY } from "../../../utils/constants/apiUrl";
import { get, deleteRecord, post } from "../../../server";
import showToast from "../../../helpers/showToast";
import { loggedInUser } from "../../../utils/store";
import Loader from "../../../components/Loader";
import ConfirmationModal from "../../../components/Modals/ConfirmationModal";
import FormInput from "../../../components/Forms/FormInput";
import searchIcon from "../../../assets/images/global_icons/searchicon.svg";
import MemoryAddEditModal from "../../../components/Modals/MemoryAddEditModal";
import _ from "lodash";

const AllMemory = () => {
  let emptyMemoryData = {
    media_type: "",
    save_type: "",
    title: "",
    media: "",
    team_id: "",
  };

  const [loggedUser, setLoggedUser] = useAtom(loggedInUser);
  const [loading, setLoading] = useState(false);
  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [memory, setMemories] = useState([]);
  const [deleteId, setDeleteId] = useState(null);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectedData, setSelectedData] = useState(emptyMemoryData);

  const handleFilter = (e) => {
    setFilterText(e.target.value);
  };

  // Handle main modal
  const handleShowModal = (obj) => {
    if (obj && Object.keys(obj).length) setSelectedData(obj);
    setShowModal(true);
  };

  const handleSaveShowModal = async () => {
    setLoading(true);

    const formData = new FormData();
    formData.append("media_type", selectedData.media_type);
    formData.append("save_type", selectedData.save_type);
    formData.append("title", selectedData.title);
    formData.append("media", selectedData.media);

    let result = {};
    if (selectedData.id) {
      result = await post(
        MEMORY + `/update/${selectedData.id}`,
        formData,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null,
      );
    } else {
      result = await post(
        MEMORY,
        formData,
        Object.keys(loggedUser).length !== 0 ? loggedUser.token : null,
      );
    }

    let { status, message, data } = result;

    if (status) {
      setLoading(false);

      let customUrlsArr = _.cloneDeep(memory);

      // On Update
      if (selectedData.id) {
        const index = memory.findIndex((el) => el.id == selectedData.id);
        customUrlsArr[index] = data;
      } else {
        customUrlsArr.push(data);
      }

      setMemories(customUrlsArr);
      handleCloseModal();
    } else {
      setLoading(false);
    }

    showToast(status, message);
  };

  const handleCloseModal = () => {
    setSelectedData(emptyMemoryData);
    setShowModal(false);
  };

  const loadMemory = async () => {
    setLoading(true);
    let { status, message, data } = await get(
      MEMORY,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null,
    );
    if (status) {
      if (data.length > 0) {
        setMemories(data);
      }
    } else {
      showToast(status, message);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadMemory();
  }, []);

  const filteredItems = useMemo(() => {
    const filtered = memory.filter(
      (item) =>
        `${item?.user_data?.first_name || ""} ${
          item?.user_data?.last_name || ""
        }`
          .toLowerCase()
          .includes(filterText.toLowerCase()) ||
        item.title.toLowerCase().includes(filterText.toLowerCase()) ||
        item.url_path.includes(filterText.toLowerCase()),
    );

    return filtered;
  }, [filterText, memory]);

  createTheme(
    "solarized",
    {
      background: {
        default: "background: var(--secondary_color)",
      },
    },
    "dark",
  );

  const columns = [
    {
      name: "Title",
      cell: (row) => <p className="globalTitle">{row.title}</p>,
    },
    {
      name: "Memory Type",
      cell: (row) => (
        <p className="globalTitle">
          {row.media_type.charAt(0).toUpperCase() + row.media_type.slice(1)}
        </p>
      ),
    },
    {
      name: "Created in",
      width: "150px",
      cell: (row) => (
        <div className={"globalDetail"}>
          {row.team_id !== null ? "Team Mode" : "Individual"}
        </div>
      ),
    },
    {
      name: "Action",
      right: "true",
      cell: (row) => (
        <div className={classes.action}>
          <button
            className="btn customActionDropdown dropdown-toggle"
            type="button"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <BsThreeDotsVertical className={"globalVerticalThreeDots"} />
          </button>
          <ul className="customActionDropdownMenu dropdown-menu dropdown-menu-end ">
            <li>
              <Link
                className="dropdown-item"
                to={`/memory/Viewmemory/${row.id}`}
              >
                View
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                onClick={() => handleShowModal(row)}
              >
                Edit
              </Link>
            </li>
            <li>
              <Link
                className="dropdown-item"
                to="#"
                style={{ color: "#E35252" }}
                onClick={() => handleDelete(row.id)}
              >
                Delete
              </Link>
            </li>
          </ul>
        </div>
      ),
    },
  ];

  // Handle confirmation modal
  const handleShowConfirmationModal = () => setShowConfirmationModal(true);
  const handleCloseConfirmationModal = () => setShowConfirmationModal(false);

  // handle delete
  const handleDelete = (id) => {
    setDeleteId(id);
    handleShowConfirmationModal(true);
  };

  const handleConfirmDelete = async () => {
    handleCloseConfirmationModal(true);
    setLoading(true);
    let { status, message } = await deleteRecord(
      `${MEMORY}/${deleteId}`,
      Object.keys(loggedUser).length !== 0 ? loggedUser.token : null,
    );
    showToast(status, message);

    if (status) {
      await loadMemory();
      setLoading(false);
    }
    setLoading(false);
  };

  return (
    <>
      {!loading ? (
        <div className="">
          <div className="page_Header">
            {/* <Link to="AddEditAdminUser">
                <button className="primary_button align_right">Add</button>
              </Link> */}
            <div className="d-flex justify-content-between align-items-md-center align-items-initial flex-md-row flex-column gap-3 mb-3">
              <div className="heading">
                <h1 className="pageTitle">
                  Memory <span>({memory.length})</span>
                </h1>
              </div>
              {/* <FormInput
                icon={searchIcon}
                placeholder="Search..."
                value={filterText}
                handleChange={handleFilter}
              /> */}
              <div
                className="input-group"
                style={{ maxWidth: "250px", height: "45px" }}
              >
                <span className="input-group-text bg-white border-end-0">
                  <img
                    src={searchIcon}
                    alt="search"
                    style={{ height: "16px" }}
                  />
                </span>
                <input
                  type="text"
                  className="form-control border-start-0"
                  placeholder="Search..."
                  value={filterText}
                  onChange={handleFilter}
                />
              </div>
            </div>
          </div>

          <div className="default-list-table">
            <DataTable
              columns={columns}
              data={filteredItems}
              paginationResetDefaultPage={resetPaginationToggle}
              pagination
              theme="solarized"
            />
          </div>

          <ConfirmationModal
            show={showConfirmationModal}
            handleCloseModal={handleCloseConfirmationModal}
            handleConfirmDelete={handleConfirmDelete}
            confirmTitle="custom url"
          />

          {/* Custom url modals */}
          {showModal && (
            <MemoryAddEditModal
              show={showModal}
              data={selectedData}
              setSelectedData={setSelectedData}
              handleSaveShowModal={handleSaveShowModal}
              handleCloseModal={handleCloseModal}
            />
          )}
        </div>
      ) : (
        <Loader />
      )}
    </>
  );
};

export default AllMemory;
